import React, { useState } from "react";
import { requestPasswordReset } from "../services/authService";

function ForgotPassword() {
    const [email, setEmail] = useState("");
    const [sent, setSent] = useState(false);

    const handleSubmit = async (e) => {
        e.preventDefault();
        await requestPasswordReset(email);
        setSent(true); // éxito siempre, mensaje genérico
    };

    return (
        <div className="panel">
            <h2>Recuperar contraseña</h2>
            {sent ? (
                <p>Si el correo existe, te hemos enviado un enlace para restablecer la contraseña.</p>
            ) : (
                <form onSubmit={handleSubmit}>
                    <input type="email" required value={email} onChange={e => setEmail(e.target.value)} placeholder="Correo" />
                    <button type="submit">Enviar enlace</button>
                </form>
            )}
        </div>
    );
}

export default ForgotPassword;

